export default __webpack_public_path__ + "Recoleta-Semibold.woff2";